<section class="whatsapp-page-bg min-h-screen w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start px-5 py-8">
  <div class="w-full max-w-3xl bg-white rounded-2xl shadow-xl border border-blue-100 p-6 md:p-8">
    <div class="flex flex-col items-center text-center gap-3">
      <img class="h-14 w-auto" src="img/logo-finco.png" alt="Logo Fincomercio">
      <h1 class="text-primary">Vinculación por WhatsApp</h1>
      <p class="text-gray-600">
        Vamos a continuar tu proceso de vinculación desde WhatsApp para darte acompañamiento paso a paso.
      </p>
    </div>

    @if (whatsappData()) {
      <div class="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        <div class="flex flex-col items-center justify-center gap-4">
          <div class="qr-wrapper">
            <img
              [src]="whatsappData()?.qrCodeDataUrl"
              alt="Código QR de vinculación por WhatsApp"
              class="qr-image"
            >
          </div>
          <p class="text-sm text-gray-500 text-center">
            Escanea este código con tu celular para abrir WhatsApp y continuar.
          </p>
        </div>

        <div class="space-y-4">
          <div class="bg-blue-50 border border-blue-100 rounded-xl p-4">
            <p class="text-sm text-gray-700">
              <b>Número de atención:</b> {{ whatsappData()?.phone }}
            </p>
          </div>

          <div class="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p class="text-sm text-gray-600">
              <b>Mensaje inicial:</b> {{ whatsappData()?.message }}
            </p>
          </div>

          <button class="btn-primary w-full" (click)="openWhatsapp()">
            Abrir WhatsApp ahora
          </button>

          <p class="text-xs text-gray-500 text-center">
            Si estás en computador, usa el QR. Si estás en celular, usa el botón para abrir la conversación.
          </p>
        </div>
      </div>
    } @else {
      <div class="mt-8 rounded-xl border border-dashed border-blue-200 bg-blue-50 p-6 text-center">
        <p class="text-gray-600">Estamos cargando la información para tu vinculación por WhatsApp.</p>
      </div>
    }
  </div>
</section>
